@use "../../styles/responsive.scss";

$component-name: "typography";

.typography {
  // Tone default: md
  --ixf-typography-size-sm: 1rem;
  --ixf-typography-line-height-sm: 1.5rem;
  --ixf-typography-letter-spacing-sm: inherit;
  --ixf-typography-color: inherit;
  --ixf-typography-font-family: var(--ixf-font-family-main);
  --ixf-typography-align: inherit;
  --ixf-typography-transform: inherit;

  color: var(--ixf-typography-color);
  font-family: var(--ixf-typography-font-family);
  margin: 0;
  padding: 0;
  text-align: var(--ixf-typography-align);
  text-transform: var(--ixf-typography-transform);

  @include responsive.responsive-props($component-name, "size", "font-size");
  @include responsive.responsive-props(
    $component-name,
    "letter-spacing",
    "letter-spacing"
  );
  @include responsive.responsive-props(
    $component-name,
    "line-height",
    "line-height"
  );
  @include responsive.responsive-props(
    $component-name,
    "font-weight",
    "font-weight"
  );

  &.variant {
    &-mono {
      --ixf-typography-font-family: var(--ixf-font-family-mono);
    }

    &-heading {
      --ixf-typography-font-family: var(--ixf-font-family-heading);
    }
  }

  &.align {
    &-left {
      --ixf-typography-align: left;
    }

    &-center {
      --ixf-typography-align: center;
    }

    &-right {
      --ixf-typography-align: right;
    }
  }

  &.as-p {
    margin: var(--ixf-space-7) 0;
  }

  &.transform {
    &-uppercase {
      --ixf-typography-transform: uppercase;
    }
  }

  &.wrap {
    &-pre-line {
      white-space: pre-line;
    }

    &-no-wrap {
      white-space: nowrap;
    }

    &-break-word {
      word-wrap: break-word;
      word-break: break-word;
      white-space: normal;
    }

    &-anywhere {
      word-wrap: anywhere;
    }

    &-preserve {
      white-space: preserve;
    }

    &-ellipsis {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  &.decoration {
    &-strikethrough {
      text-decoration: line-through;
    }

    &-none {
      text-decoration: none;
    }

    &-underline {
      text-decoration: underline;
      text-decoration-style: solid;
      text-decoration-skip-ink: auto;
      text-decoration-thickness: auto;
      text-underline-offset: auto;
      text-underline-position: from-font;
    }
  }
}
